import { PrismicError } from "./PrismicError.js";
class NotFoundError extends PrismicError {}
export { NotFoundError };
